import React, { Component } from "react";
import "./DynamicAssets.scss";
import DynamicAsset from "./DynamicAsset/DynamicAsset";
import data from "./assetData";

class DynamicAssets extends Component {
  render() {
    const assetData = data;
    const dynamicAssets = assetData.map((assetData) => {
      if (assetData.roles.includes(this.props.role)) {
        if (this.props.capability === assetData.title) {
          console.log(JSON.stringify(assetData))
          console.log(JSON.stringify(assetData.url))
          return (
            <DynamicAsset
              key={Math.random() + this.props.role}
              title={assetData.title}
              assetTitle={assetData.asset_title}
              description={assetData.description}
              ctaText={assetData.cta_text}
              ctaURL={assetData.url}
              CTAid={assetData.id}
              tabby={this.props.tabby}
            />
          );
        }
      }
    });
    return <div>{dynamicAssets}</div>;
  }
}

export default DynamicAssets;
